const footerLinks = [
  { label: '下期预告', href: '#next' },
  { label: '待证实消息', href: '#unconfirmed' },
  { label: '线人风声', href: '#whispers' },
  { label: '爆料风向标', href: '#topics' },
  { label: '常见问题', href: '#faq' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <strong className="font-heading text-base font-bold tracking-wide text-foreground-950">
                黑料最新
              </strong>
            </div>
            <p className="mt-4 font-body text-sm leading-relaxed text-foreground-700">
              以「期」为单位的预告型资讯聚合。先给标题与摘要，待核验完成后再补细节，把悬念和进度都留在页面上。
            </p>
          </div>

          <div className="flex flex-col gap-10 sm:flex-row sm:gap-16">
            <div>
              <span className="font-label text-xs font-medium tracking-[0.25em] text-secondary-700">
                站内导航
              </span>
              <nav className="mt-4 flex flex-col gap-3">
                {footerLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="cursor-pointer whitespace-nowrap font-body text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
            </div>

            <div className="max-w-xs">
              <span className="font-label text-xs font-medium tracking-[0.25em] text-secondary-700">
                阅读须知
              </span>
              <p className="mt-4 font-body text-sm leading-relaxed text-foreground-700">
                本站内容均为待证实线索与预告，不构成事实陈述。请理性围观、切勿作为传播依据。
              </p>
              <a
                href="#top"
                className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-secondary-50 px-4 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:bg-secondary-100"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-up-line" />
                </span>
                回到顶部
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <span className="font-label text-xs text-foreground-600">
            © 2026 黑料最新 · 单页演示站点
          </span>
          <span className="font-label text-xs text-foreground-500">
            预告不断更 · 09·12 第 130 期
          </span>
        </div>
      </div>
    </footer>
  );
}